<div appModal class="text-center" [showCloseButton]="false" [mainClass]="'lg-modal'" (closeModal)="close()">
  <section class="modal-container">
    <div class="content-container">
      <div class="img-container">
        <img src="/assets/images/profile-tutorial/{{ pages[currentIndex].image }}.jpg" alt="Image" />
      </div>
      <div class="text-container text-left">
        <h2>{{ pages[currentIndex].title }}</h2>
        <p>{{ pages[currentIndex].message }}</p>
      </div>
    </div>
    <div class="action-buttons">
      <button class="btn" [class.invisible]="currentIndex === 0" (click)="selectPrevious()">
        Back
      </button>
      <div class="page-indicators">
        <div
          class="page-indicator"
          *ngFor="let page of pages; let i = index"
          [class.current-page]="i === currentIndex"
        ></div>
      </div>
      <button class="btn" *ngIf="currentIndex < pages.length - 1" (click)="selectNext()">
        Next
      </button>
      <button class="btn" *ngIf="currentIndex === pages.length - 1" (click)="close()">
        Close
      </button>
    </div>
  </section>
</div>
